import { Box } from '@modusign/design-system';
import { MouseEvent as ReactMouseEvent } from 'react';

import { CheckIcon } from '@app/components/Icons';

interface CheckboxFieldCheckProps {
  height: number | string;
  opacity: number;
  width: number | string;
  onClick: (event: ReactMouseEvent<HTMLDivElement, MouseEvent>) => void;
  onMouseDown: (event: ReactMouseEvent<HTMLDivElement, MouseEvent>) => void;
}

const defaultProps = {
  height: '100%',
  opacity: 1.0,
  width: '100%',
  onClick(_event: ReactMouseEvent<HTMLDivElement, MouseEvent>) {},
  onMouseDown(_event: ReactMouseEvent<HTMLDivElement, MouseEvent>) {},
};

function CheckboxFieldCheck({
  height,
  opacity,
  width,
  onClick,
  onMouseDown,
}: CheckboxFieldCheckProps) {
  return (
    <Box
      data-testid="checkbox-field-check"
      sx={{
        height,
        width,
        fontSize: 0,
        lineHeight: 0,
      }}
      onClick={onClick}
      onMouseDown={onMouseDown}
    >
      <CheckIcon height="100%" opacity={opacity} width="100%" />
    </Box>
  );
}

CheckboxFieldCheck.defaultProps = defaultProps;

export default CheckboxFieldCheck;
